import React from 'react';
import { Dialog, DialogContent, Box, IconButton, Typography, Slide, useTheme } from '@mui/material';
import { TransitionProps } from '@mui/material/transitions';
import CloseIcon from '@mui/icons-material/Close';
import SettingsIcon from '@mui/icons-material/Settings';
import { UserSettingsGeneral } from '../../../../../../packages/app/src/components/settings/UserSettingsGeneral';

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="down" ref={ref} {...props} />;
});

interface SettingsModalProps {
  open: boolean;
  onClose: () => void;
}

export const SettingsModal: React.FC<SettingsModalProps> = ({ open, onClose }) => {
  const theme = useTheme();

  return (
    <Dialog 
      open={open} 
      onClose={onClose} 
      maxWidth="md" 
      fullWidth
      TransitionComponent={Transition}
      PaperProps={{
        sx: {
          borderRadius: 3,
          boxShadow: '0 20px 60px rgba(0,0,0,0.15)',
        }
      }}
    >
      <Box sx={{ 
        background: `linear-gradient(135deg, ${theme.palette.primary.main}15 0%, ${theme.palette.primary.light}10 100%)`,
        p: 4,
        position: 'relative'
      }}>
        <IconButton 
          onClick={onClose} 
          sx={{ 
            position: 'absolute', 
            right: 12, 
            top: 12,
            bgcolor: 'rgba(255,255,255,0.9)',
            '&:hover': { bgcolor: 'white', transform: 'rotate(90deg)' },
            transition: 'all 0.3s'
          }}
        >
          <CloseIcon />
        </IconButton>
        
        <DialogContent sx={{ p: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Box sx={{ 
              bgcolor: theme.palette.primary.main, 
              borderRadius: 2, 
              p: 1.5,
              display: 'flex',
              boxShadow: `0 4px 12px ${theme.palette.primary.main}40`
            }}>
              <SettingsIcon sx={{ fontSize: 32, color: 'white' }} />
            </Box>
            <Box>
              <Typography variant="h5" fontWeight={700}>Settings</Typography>
              <Typography variant="body2" color="text.secondary">
                Manage your preferences
              </Typography>
            </Box>
          </Box>
          
          <Box sx={{
            bgcolor: 'white',
            p: 3,
            borderRadius: 2,
            border: '1px solid',
            borderColor: 'divider',
          }}>
            <UserSettingsGeneral />
          </Box>
        </DialogContent>
      </Box>
    </Dialog>
  );
};
